import React from "react";
import "./style.css";
import img from "../../../Assets/SharedStyle/Shoman & Arab Bank - logos - Final-02_.png";
import { useSelector } from "react-redux";
export default function SAMLLoginPage() {
    const resultJson = useSelector((state) => state.FetchDataJson.JsonData);
  const handleLogin = () => {
    window.location.replace(resultJson?.internalssoUrlManagerLogin);
  };

  return (
    <div className="saml-container">
      <div className="saml-box">
        {/* Logo */}
        <div className="saml-logo">
          <img src={img} alt="Logo" />
        </div>

        {/* Title */}
        <h1 className="saml-title">{resultJson.SAMLLoginPageNameSystem}</h1>

        {/* Login Button */}
        <button className="saml-button" onClick={handleLogin}>
          تسجيل الدخول باستخدام Microsoft Saml
        </button>
      </div>
    </div>
  );
}
